// ---------------------------------------
// Query Builder JS
// NOTE: two references to SCM.QueryBuilder.configure() will need to placed in client.solrsearch.js (or equivalent file)
// 1) in SolrSearch.ajaxComplete
// 2) in SolrSearch.init
// ----------------------------------------

SCM = SCM || {};


SCM.QueryBuilder = {};

SCM.QueryBuilder.defaults = {
    runSearch: function (queryString) {
        window.location.hash = '#' + queryString;
    },
    beforeSearch: function () { }
};

SCM.QueryBuilder.configure = function () {
    var $queryFilter = $('.querybuilder-filter'),
        $queryFilterCurrentWrap = $('.querybuilder-filter-current-wrap'),
        $queryFilterDropdown = $('.querybuilder-filter-dropdown'),
        $queryInputStandard = $('.querybuilder-input-standard'),
        $queryInputCitation = $('.querybuilder-input-citation'),
        $queryInstance = $('.querybuilder-instance'),
        $queryAdd = $('.querybuilder-add');


    // if Citation filter was selected, show the appropriate fields
    var testForCitationFields = function (thisElement) {
        var $thisFilter = thisElement,
            $thisInstance = $thisFilter.closest('.querybuilder-instance');

        if ($thisFilter.hasClass('filter-citation')) {
            $thisInstance.find($queryInputStandard).addClass('hide');
            $thisInstance.find($queryInputCitation).removeClass('hide');
        } else {
            $thisInstance.find($queryInputCitation).addClass('hide');
            $thisInstance.find($queryInputStandard).removeClass('hide');
        }
    };


    // called when query input is altered or a plus button is clicked
    var testQueryInput = function (thisElement) {

        var $thisInstance = thisElement;

        // is this a citation input or a querybuilder input?
        if ($thisInstance.hasClass('citation-input')) {
            // Citation Filter
            var citeYear = $thisInstance.val().replace(/\'/g, '').trim().length,
                citeVol = $thisInstance.val().replace(/\'/g, '').trim().length,
                citeIssue = $thisInstance.val().replace(/\'/g, '').trim().length,
                citePage = $thisInstance.val().replace(/\'/g, '').trim().length;

            if (citeYear > 0 || citeVol > 0 || citeIssue > 0 || citePage > 0) {
                return true;
            } else if (citeYear === 0 && citeVol === 0 && citeIssue === 0 && citePage === 0) {
                return false;
            }

        } else {
            // Normal Filter
            var allInputsPopulated = true;
            $queryInstance.each(function () {
                if (!$(this).hasClass('hide')) {
                    var $queryInput = $(this).find('.querybuilder-input');
                    var inputSize = $queryInput.val().replace(/\'/g, '').trim().length;

                    if (inputSize === 0) {
                        allInputsPopulated = false;
                        return false;
                    } 
                }
            });

            return allInputsPopulated;
        }
    };


    // (de-)activate Add Term button if it passes testQueryInput()
    var enableDisableAddButton = function (testThisInstance) {
        testQueryInput(testThisInstance) ? $queryAdd.addClass('valid').removeAttr('disabled')
                                         : $queryAdd.removeClass('valid').attr('disabled');
    };


    // page load actions placed in anonymous function
    (function ($) {

        // count the number of instances on page load
        var $visibleInstances = 0;
        $('.querybuilder-instance').each(function () {
            if (!$(this).hasClass('hide')) {
                $visibleInstances++;
                var $operatorValue = $(this).find('[id^=operator-]');
                if ($operatorValue !== undefined && $operatorValue.length > 0) {
                    $(this).find('[id^=' + $operatorValue.val().toLowerCase() + 'Op-]').prop('checked', true);
                }
            }
        });

        // get selected filters for each visible instance when page loads
        $queryFilter.each(function () {
            var $this = $(this);
            if ($this.hasClass('selected')) {
                $this.closest($queryFilterCurrentWrap).find('.querybuilder-filter-label').text($this.text());
                testForCitationFields($this);
            }
        });

    })(jQuery);


    // show filter dropdown
    $queryFilterCurrentWrap.off('click').on('click', function (e) {
        showHideQueryFilterDropdown($(this), e);
    });

    $queryFilterCurrentWrap.off('keydown').keydown(function (e) {
        var key = e.which;
        if (key == 13) {
            showHideQueryFilterDropdown($(this), e);
        }
    });

    function showHideQueryFilterDropdown(obj, e) {
        $('.sort-order-list').addClass('hide'); // hide other dropdown on page (assume it's open)
        
        e.stopPropagation();
        
        var $thisChild = obj.find($queryFilterDropdown);
        
        // auto hide filter dropdowns OTHER than this one
        $queryFilterDropdown.not($thisChild).addClass('hide');

        $thisChild.hasClass('hide') ? $thisChild.removeClass('hide') : $thisChild.addClass('hide');
    }

    $(document).on('click', function () {
        $queryFilterDropdown.addClass('hide');
    });

    // reveal Citation input when selected from filter list
    $queryFilter.on('click', function () {
        selectQueryFilter($(this));
    });

    $queryFilter.keydown(function (e) {
        var key = e.which;
        if (key == 13) {
            selectQueryFilter($(this));
        }
    });

    function selectQueryFilter(filter) {
        var $thisFilterList = filter.closest('.querybuilder-filter-dropdown');
        var $thisLabel = filter.closest($queryFilterCurrentWrap).find('.querybuilder-filter-label');


        $thisFilterList.children(filter).removeClass('selected'); // remove '.selected' from all filters before ...
        filter.addClass('selected'); // assigning it to this filter

        $thisLabel.text(filter.text()); // set current filter label to selected
        testForCitationFields(filter);

        var filterId = filter.parents('.querybuilder-instance').attr('id');
        // Clear any errors if the filter changes
        $('#search-errors li').each(function () {
            var $this = $(this);
            if ($this.attr('from') === filterId) {
                $this.remove();
            }
        });

        var curOptionIsCitation = filter.hasClass('filter-citation');
        if (curOptionIsCitation) {
            var curCitationInstanceId = filter.closest('.querybuilder-instance').attr('id');
            //hide Citation in rest of the instances
            showCitationOptionForOtherInstances(curCitationInstanceId, false);
        } else {
            checkForCitation();
        }
    }


    // when user changes value of citation input
    $('.citation-input').on('keyup', function () {
        $('#queryBuilderSubmit').addClass('btn-green').removeAttr('style'); // something changed, notify user that they need to update
        enableDisableAddButton($(this));
    });

    
    // reveal new instance of Query Builder when plus is clicked
    $queryAdd.on('click', function () {
        
        // is the Add Term button currently disabled? Show a message
        if ($(this).attr('disabled')) {
            alert('A value must be entered before adding another filter.'); // this will eventually be a modal
        } else {
            // show next instance of QueryBuilder
            var nextInstanceNum = 1;

            // find last active QB instance (one without a class of 'hide')
            $queryInstance.each(function () {
                if (!$(this).hasClass('hide')) {
                   nextInstanceNum++;
                }
            });

            var $nextInstanceID = $('#qbInstance' + nextInstanceNum);
            var $operatorsInstanceID = $('#operators-qbInstance' + nextInstanceNum);
            if ($operatorsInstanceID !== undefined && $operatorsInstanceID.length > 0) {
                // show next QB instance & disable button
                $operatorsInstanceID.removeClass('hide');
                var $andOp = $('#andOp-qbInstance' + nextInstanceNum);
                $andOp.prop('checked', true);
            }            

            // show next QB instance & disable button
            $nextInstanceID.removeClass('hide');
            $('#instance_QueryBuilderSearchTerm-' + nextInstanceNum).focus();
            $queryAdd.removeClass('valid').attr('disabled', '');
        }

    });


    $('.querybuilder-submit').on('click', function () {
        var $isNbnjTocHf = $('#hfNbnjToc');
        if ($isNbnjTocHf.length && !$isNbnjTocHf.val()) {
            $(this).removeClass('btn-green').attr('style', 'opacity: 0.3;');
        }
    });

    $('.querybuilder-wrap').on('keyup', 'input.citation-input.citation-year', function (e) {
        var $yearField = $(e.target);
        var max = 4;
        if ($yearField.val().length > max) {
            $yearField.val($yearField.val().substr(0, max));
        }
    });

    //*Restrict Citation to only one*
    //returns the queryBuilder instanceId of the instance if citation is selected
    //returns null if no instance has Citation
    function isCitationyOptionAlreadySpecified() {
        var citeInstanceId = null;
        $queryInstance.each(function () {
            if (!$(this).hasClass('hide')) {
                var citeVisible = !$(this).find($queryInputCitation).hasClass('hide');
                if (citeVisible) {
                    citeInstanceId = $(this).attr('id');
                    return false;
                }
            }
        });
        return citeInstanceId;
    }


    //---
    //Shows or hides the citation option in the dropdow of all instances except for the one that is passed in.
    //if curCiteInstanceId is null, shows/hides citation in all instances
    //---
    function showCitationOptionForOtherInstances(curCiteInstanceId, show) {
        $queryInstance.each(function () {
            var instanceId = $queryInstance.attr('id');
            var $citeOption = $(this).find("li[data-fieldname='Citation']");

            //curCiteInstanceId=null means no instance currently has Citation.
            if (instanceId !== curCiteInstanceId || curCiteInstanceId === null) {
                show ? $citeOption.show() : $citeOption.hide();
            }
        });
    }


    //---
    //Checks if Citation is selected
    //---
    function checkForCitation() {
        var citeInstanceId = isCitationyOptionAlreadySpecified();
        if (citeInstanceId !== null) {
            //citation Option selected
            showCitationOptionForOtherInstances(citeInstanceId, false);
        } else {
            //citation Option not selected
            showCitationOptionForOtherInstances(citeInstanceId, true);
        }
    }

    $('.js-main, .js-querybuilder-wrap').off('click').on('click', '.querybuilder-submit', function () {
        createQueryStringAndRunSearch();        
    });

    //KeyUp event for Query Builder input button
    $('.querybuilder-input').off('keyup').keyup(function (e) {
        var key = e.key;
        if (key !== 'Enter') {
            $('#queryBuilderSubmit').addClass('btn-green').removeAttr('style'); // something changed, notify user that they need to update
            enableDisableAddButton($(this));
        }
        // the enter key code
        else {
            e.preventDefault();
            var inputVal = $.trim($(this).val());
            if (inputVal !== '') {
                createQueryStringAndRunSearch();
                return false;
            }
        }
    });

    //---
    //Checks if Citation is selected
    //---
    function createQueryStringAndRunSearch() {
        var queryString = '';
        if ($('.js-custom-queryBuilder').length > 0) {
            queryString = SCM.CustomQueryBuilder.queryBuilderHandler();
        }
        else {
            var currentSearchTerm = $('#hfCurrentSearchTerm').val();    //Existing Search Term
            var currentDataUrl = $('.querybuilder-submit').attr('data-current-url');
            var queryParams = currentDataUrl.split('&');
            // strip out is latest edition filter since we're starting a new query
            queryParams = $.grep(queryParams, function (param) {
                var key = param.split('=')[0];
                return key.indexOf('fd_IsLatestEdition') < 0;
            });
            currentDataUrl = queryParams.join('&');
            var qbObject = new Object();
            var instanceIndex = 1;
            var qbObjectInitialized = false;
            var searchErrors = $('#search-errors');

            //Updates the DataUrl for the All option
            function updateDataUrlForAllOption(searchTerm, currentDataUrl) {
                var newQueryTerm = '';
                var updatedUrl = '';

                if (currentDataUrl.indexOf('q=') >= 0) {
                    var queryTerm = SCM.Common.getQueryStringValue(currentDataUrl, 'q');
                    if (!queryTerm.startsWith('(')) {
                        //prepend open parenthesis
                        newQueryTerm = '(';
                    }
                    if (queryTerm.endsWith(')')) {
                        //existing queryTerm ends with ")" - remove it and then append " AND {qt})
                        newQueryTerm = newQueryTerm + queryTerm.slice(0, -1) + ' AND ' + searchTerm + ')';
                    } else {
                        newQueryTerm = newQueryTerm + queryTerm + ' AND ' + searchTerm + ')';
                    }
                    updatedUrl = currentDataUrl.replace(queryTerm, newQueryTerm);
                }
                else {
                    //"q" parm does not exist in currentDataUrl
                    updatedUrl = 'q=' + searchTerm + '&' + currentDataUrl;
                }
                return updatedUrl;
            }

            function isNullOrEmpty(val) {
                return val === null || val === '' || val === undefined;
            }

            function clearErrors() {
                searchErrors.empty();
            }

            function displayErrors(validationErrors) {
                function validationMessage(error) {
                    var $elem = $('<li>');
                    $elem.text(error.message);
                    $elem.attr('from', error.origin);
                    return $elem;
                }

                var $ul = $('<ul>');
                searchErrors.append($ul);

                $.each(validationErrors, function (i, val) {
                    $ul.append(validationMessage(val));
                });
            }

            var validationErrors = [];

            clearErrors();
            //loop through all instances
            $('.querybuilder-wrap .querybuilder-instance').each(function () {
                var $this = $(this);
                //process only the instances which are visible
                var instanceVisible = !$this.hasClass('hide');
                if (instanceVisible) {
                    //find the search term (#QueryBuilderSearchTerm - parent Div: querybuilder-input-standard)
                    var qbInputElement = $this.find('#instance_QueryBuilderSearchTerm');
                    // If the default behaviour failed, fall back to OUP-specific class-name
                    if (qbInputElement.length === 0) {
                        qbInputElement = $this.find('.querybuilder-input').val().trim();
                    }
                    else {
                        qbInputElement = qbInputElement.val().trim();
                    }
                    // remove the quotes from the qb component since it chokes on the back end
                    // TODO:  Fix back end so it can handle the quotes
                    qbInputElement = qbInputElement.replace(/\"/g, '');
                    //get the text and value for the dropdown item
                    var qbSearchTypeDisplayName = $this.find('.querybuilder-filter-dropdown li.selected').text();
                    var qbSearchTypeFieldName = $this.find('.querybuilder-filter-dropdown li.selected').attr('data-fieldname');

                    //The 1st instance defaults to SearchTerm ("q") w/o any filter with the user having the abiliity to change it to a filter. 
                    var filterSpecifiedForSearchTerm = false;
                    if (instanceIndex === 1) {

                        var searchTerm = encodeURIComponent(qbInputElement);

                        //check if user converted SearchTerm to a filter.
                        if (typeof qbSearchTypeFieldName !== 'undefined' && qbSearchTypeFieldName !== null && $.trim(qbSearchTypeFieldName) !== '' && searchTerm !== '') {
                            //remove q parameter because searchTerm needs to be executed against a particular field
                            var qTerm = SCM.Common.getQueryStringValue(currentDataUrl, 'q');
                            if (qTerm !== null && qTerm !== '') {
                                qTerm = 'q=' + qTerm + '&';
                                currentDataUrl = currentDataUrl.replace(qTerm, '');
                            }
                            else {
                                qbObject = new Object();
                            }

                            filterSpecifiedForSearchTerm = true;
                        }
                        else {
                            //user didn't change the searchTerm to Filter - Execute this as "q"
                            if (encodeURIComponent(currentSearchTerm) !== searchTerm) {
                                // This check is for the q= parameter. Weird stuff happens when this parameter is missing (blank search).
                                var startIndex = currentDataUrl.indexOf('q=');
                                if (startIndex >= 0 && currentDataUrl.indexOf('&', startIndex) >= 0) {
                                    var currentQuery = SCM.Common.getQueryStringValue(currentDataUrl, 'q');
                                    if (currentQuery !== null && currentQuery !== '') {
                                        currentQuery = 'q=' + currentQuery + '&';
                                        currentDataUrl = currentDataUrl.replace(currentQuery, 'q=' + searchTerm + '&');
                                    }
                                    else {
                                        currentDataUrl = 'q=' + searchTerm + '&' + currentDataUrl;
                                    }
                                } else {
                                    currentDataUrl = 'q=' + searchTerm + '&' + currentDataUrl;
                                }
                            }

                            //to identify this particular condition, setting this as "q" so Model can process it appropriately.
                            qbObject.q = searchTerm;
                            qbObjectInitialized = true;

                            if (searchTerm === '') {
                                currentDataUrl = currentDataUrl.replace('q=&', '');
                                return true;
                            }

                            //skip this iteration and process the next item.
                            instanceIndex++;
                            return true;
                        }
                    }

                    switch (qbSearchTypeDisplayName) {
                        case '':
                            //User specified a value for searchTerm but didn't select an option from dropdown.
                            //Same as All (searchTerm will be executed as Q)
                            var keyOptionOrdinal = 'q' + instanceIndex;
                            if (qbInputElement !== '') {
                                var qbSearchTerm = qbInputElement;
                                currentDataUrl = updateDataUrlForAllOption(qbSearchTerm, currentDataUrl);
                                qbObject[keyOptionOrdinal] = encodeURIComponent(qbSearchTerm);
                                qbObjectInitialized = true;
                            }
                            break;
                        case 'All':
                            if (qbInputElement !== '') {
                                var qbSearchTerm = encodeURIComponent(qbInputElement);
                                currentDataUrl = updateDataUrlForAllOption(qbSearchTerm, currentDataUrl);

                                //Since there could me multiple "All"s, tagging ordinal to make them unique.
                                var keyName = 'All' + instanceIndex;
                                if (instanceIndex === 1 && filterSpecifiedForSearchTerm || instanceIndex !== 1) {
                                    qbObject[keyName] = qbSearchTerm;
                                    qbObjectInitialized = true;
                                }
                            }
                            break;
                        case 'Citation':
                            var citationObj = {};

                            //Since there could me multiple "Citation"s, tagging ordinal to make them unique.
                            var keyCitationName = 'Citation' + instanceIndex;

                            var citationFields = [
                                {
                                    id: '#instance_CitationYear',
                                    field: 'Year',
                                    pattern: /^(?!0(0?){3})\d(\d?){3}$/,
                                    message: "The 'Year' field only accepts numbers."
                                },
                                {
                                    id: '#instance_CitationVolume',
                                    field: 'Volume'
                                },
                                {
                                    id: '#instance_CitationIssueNo',
                                    field: 'IssueNo'
                                },
                                {
                                    id: '#instance_CitationPage',
                                    field: 'StartPage'
                                }
                            ];

                            $.each(citationFields, function (_, val) {
                                var $field = $this.find(val.id);
                                var value = $field.val().trim();

                                if (!isNullOrEmpty(value)) {
                                    if (!qbObject[keyCitationName]) {
                                        qbObject[keyCitationName] = citationObj;
                                        qbObjectInitialized = true;
                                    }

                                    if (val.pattern && !val.pattern.test(value)) {
                                        $field.val('');

                                        if ($.inArray(val.message, validationErrors) === -1) {
                                            validationErrors.push({ message: val.message, origin: 'qbInstance' + instanceIndex });
                                        }
                                    } else {
                                        citationObj[val.field] = value;
                                    }
                                }
                            });
                            break;
                        default:
                            var keyDefName = qbSearchTypeFieldName + instanceIndex;
                            if (qbInputElement !== '') {
                                var qbSearchTerm = qbInputElement;
                                qbObject[keyDefName] = encodeURIComponent(qbSearchTerm);
                                qbObjectInitialized = true;
                            }
                            break;
                    }

                }
                instanceIndex++;
            });

            if (validationErrors.length > 0) {
                displayErrors(validationErrors);
                $('#queryBuilderSubmit').addClass('btn-green').removeAttr('style');
                return;
            }

            //remove pagination if exists
            var page = SCM.Common.getQueryStringValue(currentDataUrl, 'page');

            if (currentDataUrl === 'page=1') {
                currentDataUrl = '&page=1';
            }
            if (page !== null && page !== '') {
                currentDataUrl = currentDataUrl.replace('page=' + page + '&', 'page=1&');
            }

            queryString = currentDataUrl;

            if (qbObjectInitialized) {
                var qbObjectParms = JSON.stringify(qbObject);
                var oldQb = SCM.Common.getQueryStringValue(currentDataUrl, 'qb');
                if (oldQb) {
                    queryString = queryString.replace(oldQb, qbObjectParms);
                }
                else {
                    queryString = queryString + '&qb=' + qbObjectParms;
                }
            }
        }
        SCM.QueryBuilder.defaults.beforeSearch();
        SCM.QueryBuilder.defaults.runSearch(queryString);
    }
};

//NARN-3759 - .startsWith is not supported by IE - Polyfill - BENC - 9/15/2016
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

//NARN-3759 - .endsWith is not supported by IE - Polyfill - BENC - 9/15/2016
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}